import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useEffect, useMemo, useRef } from 'react';
import { motion } from 'motion/react';

import Message from '../Message/Message';
import { useGetParams } from '../../hooks/useGetParams';
import styles from './MessagesList.module.css';

import quizBg from '../../assets/video/bgVideo.webm';
import quizBgPoster from '../../assets/images/bgPoster.webp';
import logo from '../../assets/images/logoRnd.webp';
import delo from '../../assets/images/delo.png';
import ncsp from '../../assets/images/ncsp.png';

import confetti from '../../assets/video/confetti.webm';

export const MessagesList = ({
  messages,
  currentState,
  winId,
  speed,
  mode,
}) => {
  const confettiRef = useRef(null);

  const isWinner = useMemo(() => currentState === 'S6', [currentState]);

  const { authorFontSize, user } = useGetParams();

  useEffect(() => {
    let idTimeout = '';
    if (confettiRef.current && isWinner) {
      idTimeout = setTimeout(() => {
        confettiRef.current.play().catch((error) => {});
      }, 1500);
    } else if (idTimeout) {
      clearTimeout(idTimeout);
    }
    return () => {
      clearTimeout(idTimeout);
    };
  }, [isWinner]);

  const letters = 'ПОБЕДИТЕЛЬ!'.split('');

  return (
    <div className={styles['wrapper']}>
      <img src={logo} alt="logo" className={styles.logo} />
      <img src={delo} alt="delo" className={styles.delo} />
      <img src={ncsp} alt="ncsp" className={styles.ncsp} />

      <div className={styles.firstLine}>
        {isWinner &&
          letters.map((l, idx, arr) => {
            let initialIdx = 5;
            let oneLetterWidth = 6;
            let initialX = `${(idx - initialIdx) * oneLetterWidth * -1}rem`;

            return (
              <motion.div
                style={{ position: 'relative', zIndex: idx * -1 }}
                key={l + idx}
                initial={{
                  scale: 0,
                  x: initialX,
                }}
                animate={{
                  scale: 1,
                  x: 0,
                }}
                transition={{
                  duration: 0.5,
                  delay: idx * 0.1 + 1.2,
                }}
              >
                {l}
              </motion.div>
            );
          })}
      </div>

      <div className={styles.messagesWrapper}>
        <TransitionGroup className={styles.messages}>
          {messages.length > 0 &&
            messages.map((item, i) => {
              const msg = mode === 'allMessages' ? item.message : item;
              const key =
                mode === 'allMessages'
                  ? item.id
                  : item.senderNumber + item.author;
              const currentId =
                mode === 'allMessages' ? item.id : item.senderNumber;

              return (
                <CSSTransition
                  key={item.UUID}
                  timeout={speed}
                  classNames="position"
                >
                  <Message
                    isWinner={isWinner}
                    winId={winId}
                    key={key}
                    message={msg}
                    authorFontSize={authorFontSize}
                    currentId={currentId}
                    user={user}
                  />
                </CSSTransition>
              );
            })}
        </TransitionGroup>
      </div>

      {isWinner && (
        <video
          ref={confettiRef}
          muted="muted"
          loop
          playsInline
          className={styles.confetti}
        >
          <source src={confetti} type="video/webm"></source>
        </video>
      )}

      <video
        playsInline
        autoPlay="autoplay"
        muted="muted"
        loop
        id="bgVideo"
        poster={quizBgPoster}
      >
        <source src={quizBg} type="video/webm" />
      </video>
    </div>
  );
};
